export const NAMESPACE = 'job';

export const COMMANDS_FETCH_LOADING = 'loading';
export const COMMANDS_FETCH_FAILURE = 'failure';
export const COMMANDS_FETCH_SUCCESS = 'success';
